import { Agent, AiRoute, LazyPage } from './-components';
import { createFileRoute } from '@tanstack/react-router';

function AgentIndexRoute() {
  return (
    <AiRoute>
      <LazyPage>
        <Agent />
      </LazyPage>
    </AiRoute>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/agent/')({
  component: AgentIndexRoute,
});
